import React from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { LOAD_DOCS_DATA, GET_PRIVACY_HEALTHPLAN_TEXT, GET_PRIVACY_MYBSWH_TEXT, GET_PRIVACY_MYCHART_TEXT } from "../../constants/actionTypes";
import { Privacy_HealthPlan, Privacy_MyBswh, Privacy_MyChart, Privacy_HealthPlan_FallBack_Text, Privacy_MyBswh_FallBack_Text, Privacy_MyChart_FallBack_Text } from "../../constants/textConstants";
import StaticHtmlContent from "../common/staticHtmlContent";
import Spinner from "../common/spinner";
import { Notifier } from "../ecosystem";

class Privacy extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTabs = this.toggleTabs.bind(this);
        this.state = { activeTab: '1' }
        this.navRow = React.createRef()
    }

    componentDidMount() {        
        this.props.getPrivacy_MyBswhText(Privacy_MyBswh, this.props.token);
        this.props.getPrivacy_MyChartText(Privacy_MyChart, this.props.token);
        if (this.props.hasSWHP || this.props.hasFirstCare) {
            this.props.getPrivacy_HealthPlanText(Privacy_HealthPlan, this.props.token);
        }        
    }

    toggleTabs(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
        //scroll horizontal menu item into view on mobile
        if (tab === '1') {
            if (this.navRow.current) {
                this.navRow.current.scrollLeft = 0
            }
        }
        else if (tab === '3') {
            if (this.navRow.current) {
                this.navRow.current.scrollLeft = 200
            }
        }
    }

    ShowSpinner(hasSWHP, hasFirstCare, healthPlanPrivacydata, bswhPrivacydata, myChartPrivacyData) {
        let spin = false;
        const { activeTab } = this.state;
        if (hasSWHP || hasFirstCare) {
            spin = (healthPlanPrivacydata && bswhPrivacydata && myChartPrivacyData)?true:false;
            }
        else {
            spin = ((bswhPrivacydata && activeTab === '1') || (myChartPrivacyData && activeTab === '2')) ? true : false;
        }
        return spin;
    }
    
    render() {
        const { isLoggedIn, hasSWHP, hasFirstCare, insuranceName, healthPlanPrivacydata, bswhPrivacydata, myChartPrivacyData, technicalHelpDeskHours, technicalHelpDeskNumber } = this.props;
        const helpDesk = `please contact the MyBSWHealth technical help desk ${technicalHelpDeskHours} at <a href=${'tel:' + technicalHelpDeskNumber} class='bsw-phone-link'>${technicalHelpDeskNumber}</a>.`;
        const insuranceNameText = insuranceName ? insuranceName : hasSWHP ? "Baylor Scott & White Health Plan" : "FirstCare Health Plans";
        const helpDeskHP = `please contact member support at <a href=${'tel:1.800.321.7947'} class='bsw-phone-link'>1.800.321.7947</a>.`;
        const privacyMyBswhFallBackText = `${Privacy_MyBswh_FallBack_Text}${helpDesk}`;
        const privacyMyChartFallBackText = `${Privacy_MyChart_FallBack_Text}${helpDesk}`;
        const privacyHealthPlanFallBackText = `${Privacy_HealthPlan_FallBack_Text}${helpDeskHP}`;
        const colorStyle = 'error';
        let icon = 'exclamation';
        return (<div className={"container-fluid body-content privacy-container" + (isLoggedIn ? " logged-in-container" : " logged-out-container")}>
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div id="top" />
                    <div className="row">
                        <div className="col-12">
                            <div className="page-heading">Digital Privacy Policy</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 nav-row" ref={this.navRow}>
                            <Nav tabs>
                                <NavItem >
                                    <NavLink className={this.state.activeTab === '1' ? 'active' : ''} onClick={() => this.toggleTabs('1')} >
                                        MYBSWHEALTH
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={this.state.activeTab === '2' ? 'active' : ''} onClick={() => this.toggleTabs('2')} >
                                        MYCHART
                                    </NavLink>
                                </NavItem>
                                {(hasSWHP || hasFirstCare) && <NavItem>
                                    <NavLink className={this.state.activeTab === '3' ? 'active' : ''} onClick={() => this.toggleTabs('3')}>
                                        {insuranceNameText.toUpperCase()}
                                    </NavLink>
                                </NavItem>}
                            </Nav>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1">

                                    <StaticHtmlContent content={bswhPrivacydata && !bswhPrivacydata.error && bswhPrivacydata.text} />
                                    {bswhPrivacydata && !bswhPrivacydata.isFetching && (bswhPrivacydata.error || !bswhPrivacydata.text) &&
                                        <Notifier
                                            colorStyle={colorStyle}
                                            icon={icon}
                                            show={true}
                                            variant="inline"
                                        ><StaticHtmlContent content={privacyMyBswhFallBackText} />
                                        </Notifier>
                                    }
                                </TabPane>
                                <TabPane tabId="2">
                                    <StaticHtmlContent content={myChartPrivacyData && !myChartPrivacyData.error && myChartPrivacyData.text} />
                                    {myChartPrivacyData && !myChartPrivacyData.isFetching && (myChartPrivacyData.error || !myChartPrivacyData.text) &&
                                        <Notifier
                                            colorStyle={colorStyle}
                                            icon={icon}
                                            show={true}
                                            variant="inline"
                                        ><StaticHtmlContent content={privacyMyChartFallBackText} />
                                        </Notifier>
                                    }
                                </TabPane>
                                {(hasSWHP || hasFirstCare) && <TabPane tabId="3">
                                    <StaticHtmlContent content={healthPlanPrivacydata && !healthPlanPrivacydata.error && healthPlanPrivacydata.text} />
                                    {healthPlanPrivacydata && !healthPlanPrivacydata.isFetching && (healthPlanPrivacydata.error || !healthPlanPrivacydata.text) &&
                                        <Notifier
                                            colorStyle={colorStyle}
                                            icon={icon}
                                            show={true}
                                            variant="inline"
                                        >
                                            <StaticHtmlContent content={privacyHealthPlanFallBackText} />
                                        </Notifier>
                                    }
                                </TabPane>}
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
            {this.ShowSpinner(hasSWHP,hasFirstCare,(typeof healthPlanPrivacydata === 'undefined' || healthPlanPrivacydata.isFetching),(typeof bswhPrivacydata === 'undefined' || bswhPrivacydata.isFetching),(typeof myChartPrivacyData === 'undefined' || myChartPrivacyData.isFetching)) &&
                <Spinner />
            }
        </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        myChartPrivacyData: state.docs.docsData,
        hasSWHP: state.memberships.hasAnySWHP,
        hasFirstCare: state.memberships.hasFC,
        insuranceName: state.session.insuranceName,
        healthPlanPrivacydata: state.docs.healthPlanPrivacydata,
        bswhPrivacydata: state.docs.bswhPrivacydata,
        myChartPrivacyData: state.docs.myChartPrivacyData,
        token: state.sso.userDetails.access_token,
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : '',
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : ''       
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrivacy_HealthPlanText: (featureId, token) => {
            dispatch({
                type: GET_PRIVACY_HEALTHPLAN_TEXT,
                featureId: featureId,
                token: token
            });
        },
        getPrivacy_MyBswhText: (featureId, token) => {
            dispatch({
                type: GET_PRIVACY_MYBSWH_TEXT,
                featureId: featureId,
                token: token
            });
        },
        getPrivacy_MyChartText: (featureId, token) => {
            dispatch({
                type: GET_PRIVACY_MYCHART_TEXT,
                featureId: featureId,
                token: token
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);